module.exports = __webpack_public_path__ + "321de4f08c1b90ee38bb3f83f42a9f6f.png";